import { COMPONENT_NAME as CREATE_EDIT_SUPPLIER_MESSAGE_COMPONENT_NAME, CreateEditSupplierMessageComponent } from "./create-edit-supplier-message/create-edit-supplier-message.component"

export const COMPONENTS_MODULE_NAME = 'simax.supplier.message.components'

const module = angular.module(COMPONENTS_MODULE_NAME, [])

module.component(CREATE_EDIT_SUPPLIER_MESSAGE_COMPONENT_NAME, new CreateEditSupplierMessageComponent())